function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.613 1.21a1 1 0 00-1.228 0l-9 7a1 1 0 00-.386.79v11a3 3 0 003 3h14a3 3 0 003-3V9a1 1 0 00-.386-.79l-9-7zM15.999 21h3a1 1 0 001-1V9.49l-8-6.223-8 6.222V20a1 1 0 001 1h3v-9a1 1 0 011-1h6a1 1 0 011 1v9zm-6 0v-8h4v8h-4z",
  fill: "#6E0BD0"
});

function SvgCityinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgCityinline;